import { render, staticRenderFns } from "./VendorReport.vue?vue&type=template&id=167058fd&"
import script from "./VendorReport.vue?vue&type=script&lang=js&"
export * from "./VendorReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports